export interface IScheduleOption {
  name: string;
  value: string | number;
}
